export default __webpack_public_path__ + "static/gbenga-5c7a7c4f2fb1362a6d1e68d5fd8c2e35.png";